import { ADMIN_STATS } from '../../types';

export default {
  state: {
    homeStatsQuery: null,
    homeStatsMonthQuery: null,
    avgCommuteDistanceStatsQuery: null,
    avgCommuteDistanceModeStatsQuery: null,
    employerFilterId: null,
  },
  getters: {
    homeStatsQueryData(state) {
      if (!state.homeStatsQuery) return null;
      return state.homeStatsQuery.data || null;
    },
    homeStatsMonthQueryData(state) {
      if (!state.homeStatsMonthQuery) return null;
      return state.homeStatsMonthQuery.data || null;
    },
    avgCommuteDistanceDataAdmin(state) {
      if (!state.avgCommuteDistanceStatsQuery) return null;
      return state.avgCommuteDistanceStatsQuery.data || null;
    },
    avgCommuteModeDistanceDataAdmin(state) {
      if (!state.avgCommuteDistanceModeStatsQuery) return null;
      return state.avgCommuteDistanceModeStatsQuery.data || null;
    },
    employerFilterIdData(state) {
      if (!state.employerFilterId) return null;
      return state.employerFilterId || null;
    },
  },
  mutations: {
    [ADMIN_STATS.SET_HOME_STATS_QUERY](state, payload) {
      state.homeStatsQuery = payload;
    },
    [ADMIN_STATS.SET_HOME_STATS_MONTH_QUERY](state, payload) {
      state.homeStatsMonthQuery = payload;
    },
    [ADMIN_STATS.SET_AVG_COMMUTE_DISTANCE_STATS_QUERY](state, payload) {
      state.avgCommuteDistanceStatsQuery = payload;
    },
    [ADMIN_STATS.SET_AVG_COMMUTE_MODE_DISTANCE_STATS_QUERY](state, payload) {
      state.avgCommuteDistanceModeStatsQuery = payload;
    },
    [ADMIN_STATS.SET_EMPLOYER_FILTER_ID](state, payload) {
      state.employerFilterId = payload;
    },
  },
  actions: {},
};
